import type React from 'react';
import { useCallback, useState } from 'react';

export interface DialogProps {
  onClose: () => void;
  isHidden: boolean;
}

interface UseDialogWithExtraPropsShape<T> {
  closeDialog: () => void;
  dialog: JSX.Element | null;
  openDialog: (extraProps: T) => void;
}

export function useDialogWithExtraProps<T extends DialogProps>(
  DialogComponent: React.VFC<Omit<T, keyof DialogProps> & DialogProps>,
): UseDialogWithExtraPropsShape<Omit<T, keyof DialogProps>> {
  const [extraProps, setExtraProps] = useState<Omit<T, keyof DialogProps>>();

  return {
    dialog:
      extraProps !== undefined ? (
        <DialogComponent {...extraProps} isHidden={extraProps === undefined} onClose={() => setExtraProps(undefined)} />
      ) : null,
    openDialog: useCallback(newExtraProps => setExtraProps(newExtraProps), []),
    closeDialog: useCallback(() => setExtraProps(undefined), []),
  };
}
